export default "__VITE_ASSET__BEiweXZI__"